module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "answer-modal",
    class: {
      'answer-modal--with-sidebar': _vm.isShowAbsenceSidebar
    }
  }, [_c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    class: {
      'd-modal--with-opus': _vm.isShowSalaryInfoBox
    },
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['answer_absence_request']))]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__header-actions"
  }, [(!_vm.isShowAbsenceSidebar) ? _c('button', {
    staticClass: "do-bttn do-bttn--small",
    on: {
      "click": function($event) {
        _vm.isShowAbsenceSidebar = true
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.i18n['show_absent']) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-modal__close icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content-wrapper"
  }, [_c('div', {
    staticClass: "d-modal__content"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', [_c('b', [_vm._v(_vm._s(_vm.request.vUserName) + ":")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.request.vSubjectTitle) + ",")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.request.vStart) + " -")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.request.vEnd))])]), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-top": "1px solid #e2e8f0"
    }
  }, [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.request.request_note))])])])]), _vm._v(" "), _c('div', {
    staticClass: "marg-1-top"
  }, [_c('label', {
    staticClass: "d-label marg-05-bottom"
  }, [_vm._v(_vm._s(_vm.i18n['absence_reason']))]), _vm._v(" "), _c('UserAbsence', {
    attrs: {
      "isShowLabel": false,
      "selectedSubject": {
        id: _vm.request.subject_id
      }
    },
    on: {
      "setSubject": _vm.updateRequestSubject
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n['date']))]), _vm._v(" "), _c('DatepickerRange', {
    attrs: {
      "allowSameDate": true,
      "startdate": _vm.initStartDate,
      "enddate": _vm.initEndDate
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "time-changer__group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n['time']))]), _vm._v(" "), _c('TimeChanger', {
    attrs: {
      "showIcon": true,
      "start": _vm.startTime,
      "end": _vm.endTime,
      "isFiveMinutesInterval": false
    },
    on: {
      "updateStart": _vm.setStartTime,
      "updateEnd": _vm.setEndTime
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "marg-1-top"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.i18n['reply_note']))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "do-input do-textarea",
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.isShowSdInfoBox) ? _c('div', {
    staticClass: "opus-info-box"
  }, [_c('div', {
    staticClass: "do-sd-badge do-opus-badge--large opus-info__header"
  }, [_vm._v("SD")]), _vm._v(" "), (_vm.userEmployments.length > 0) ? _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Ansættelse")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedEmploymentId),
      expression: "selectedEmploymentId"
    }],
    staticClass: "do-select",
    class: {
      'do-select--error': _vm.showValidationErrors && !_vm.isEmploymentValid
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedEmploymentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("— Vælg ansættelsesnummer —")]), _vm._v(" "), _vm._l((_vm.userEmployments), function(employment) {
    return _c('option', {
      key: employment.id,
      domProps: {
        "value": employment.id
      }
    }, [_vm._v("\n              " + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number || employment.id) + "\n            ")])
  })], 2), _vm._v(" "), (_vm.showValidationErrors && !_vm.isEmploymentValid) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("\n            Ansættelsesnummer skal vælges\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Fraværsårsag")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__reason-display"
  }, [(_vm.getSDAbsence) ? _c('span', {
    staticClass: "opus-info__reason-code"
  }, [_vm._v("\n              " + _vm._s(_vm.getSDAbsence.loenart) + _vm._s(_vm.getSDAbsence.title ? ' - ' + _vm.getSDAbsence.title : '') + "\n            ")]) : _vm._e()])]), _vm._v(" "), (_vm.isSdOngoingAllowed) ? _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Åbenstående")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__toggle-row"
  }, [_c('div', {
    staticClass: "do-opus-toggle",
    on: {
      "click": function($event) {
        _vm.isOngoing = !_vm.isOngoing
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "prop-on": _vm.isOngoing
    }
  }), _vm._v(" "), _c('span', [_vm._v("Indberet som åbenstående")])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Tid")]), _vm._v(" "), (_vm.useTime) ? _c('div', {
    staticClass: "opus-info__date-text"
  }, [_vm._v("\n            " + _vm._s(_vm.formatTime(_vm.startTime)) + " - " + _vm._s(_vm.formatTime(_vm.endTime)) + "\n          ")]) : _c('div', {
    staticClass: "opus-info__date-text"
  }, [_vm._v("\n            Hel dag\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
  }, [_c('div', {
    staticClass: "do-opus-toggle",
    on: {
      "click": function($event) {
        _vm.useTime = !_vm.useTime
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "prop-on": !_vm.useTime
    }
  }), _vm._v(" "), _c('span', [_vm._v("Indberet som hel dag")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isShowOpusInfoBox) ? _c('div', {
    staticClass: "opus-info-box"
  }, [_c('div', {
    staticClass: "do-opus-badge do-opus-badge--large opus-info__header"
  }, [_vm._v("Opus")]), _vm._v(" "), (_vm.userEmployments.length > 0) ? _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Ansættelse")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedEmploymentId),
      expression: "selectedEmploymentId"
    }],
    staticClass: "do-select",
    class: {
      'do-select--error': _vm.showValidationErrors && !_vm.isEmploymentValid
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedEmploymentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onEmploymentChange]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("— Vælg ansættelsesnummer —")]), _vm._v(" "), _vm._l((_vm.userEmployments), function(employment) {
    return _c('option', {
      key: employment.id,
      domProps: {
        "value": employment.id
      }
    }, [_vm._v("\n              " + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number || employment.id) + "\n            ")])
  })], 2), _vm._v(" "), (_vm.showValidationErrors && !_vm.isEmploymentValid) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("\n            Ansættelsesnummer skal vælges\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Fraværsårsag")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__reason-display"
  }, [(_vm.getOPUSAbsence) ? _c('span', {
    staticClass: "opus-info__reason-code"
  }, [_vm._v("\n              " + _vm._s(_vm.getOPUSAbsence.absence_type) + _vm._s(_vm.getOPUSAbsence.absence_type_text ? ' - ' + _vm.getOPUSAbsence.absence_type_text : '') + "\n            ")]) : _vm._e()]), _vm._v(" "), (_vm.isShowExtraInformation) ? _c('div', {
    staticClass: "opus-info__extra-info"
  }, [(_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Maternity') ? [_c('label', {
    staticClass: "opus-info__label opus-info__label--secondary"
  }, [_vm._v("Ekstra information til barselssager")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
    staticClass: "do-spinner do-spinner--small"
  }) : (_vm.additionalDataError) ? _c('div', {
    staticClass: "opus-info__error"
  }, [_c('span', {
    staticClass: "opus-info__error-icon"
  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAdditionalData),
      expression: "selectedAdditionalData"
    }],
    staticClass: "do-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
    return _c('option', {
      key: option.MaternityCaseKey,
      domProps: {
        "value": option.MaternityCaseKey
      }
    }, [_vm._v("\n                  " + _vm._s(option.ExpectedDeliveryDate) + " - " + _vm._s(option.MaternityCaseKey) + "\n                ")])
  })], 2) : (_vm.hasLoadedAdditionalData) ? _c('p', {
    staticClass: "opus-info__note"
  }, [_vm._v("\n                Der er ingen barselssager tilknyttet denne medarbejder i Opus.\n              ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Reason') ? [_c('label', {
    staticClass: "opus-info__label opus-info__label--secondary"
  }, [_vm._v("Ekstra information til tjenestefri")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
    staticClass: "do-spinner do-spinner--small"
  }) : (_vm.additionalDataError) ? _c('div', {
    staticClass: "opus-info__error"
  }, [_c('span', {
    staticClass: "opus-info__error-icon"
  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAdditionalData),
      expression: "selectedAdditionalData"
    }],
    staticClass: "do-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
    return _c('option', {
      key: option.ReasonCode,
      domProps: {
        "value": option.ReasonCode
      }
    }, [_vm._v("\n                  " + _vm._s(option.ReasonCodeText) + " - " + _vm._s(option.ReasonCode) + "\n                ")])
  })], 2) : (_vm.hasLoadedAdditionalData) ? _c('p', {
    staticClass: "opus-info__note"
  }, [_vm._v("\n                Der er ingen tjenestefri årsager tilknyttet denne medarbejder i Opus.\n              ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'WorkInjury') ? [_c('label', {
    staticClass: "opus-info__label opus-info__label--secondary"
  }, [_vm._v("Ekstra information til arbejdsskader")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
    staticClass: "do-spinner do-spinner--small"
  }) : (_vm.additionalDataError) ? _c('div', {
    staticClass: "opus-info__error"
  }, [_c('span', {
    staticClass: "opus-info__error-icon"
  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAdditionalData),
      expression: "selectedAdditionalData"
    }],
    staticClass: "do-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
    return _c('option', {
      key: option.AccidentNumber,
      domProps: {
        "value": option.AccidentNumber
      }
    }, [_vm._v("\n                  " + _vm._s(option.AccidentDate) + " - " + _vm._s(option.AccidentNumber) + "\n                ")])
  })], 2) : (_vm.hasLoadedAdditionalData) ? _c('p', {
    staticClass: "opus-info__note"
  }, [_vm._v("\n                Der er ingen arbejdsskadesager tilknyttet denne medarbejder i Opus.\n              ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.getOPUSAbsence && _vm.getOPUSAbsence.additional_data === 'Child') ? [_c('label', {
    staticClass: "opus-info__label opus-info__label--secondary"
  }, [_vm._v("Ekstra information til omsorgsdage")]), _vm._v(" "), (_vm.isLoadingAdditionalData) ? _c('div', {
    staticClass: "do-spinner do-spinner--small"
  }) : (_vm.additionalDataError) ? _c('div', {
    staticClass: "opus-info__error"
  }, [_c('span', {
    staticClass: "opus-info__error-icon"
  }, [_vm._v("⚠")]), _vm._v(" "), _c('span', [_vm._v("Kunne ikke hente data fra Opus")])]) : (_vm.additionalDataOptions.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAdditionalData),
      expression: "selectedAdditionalData"
    }],
    staticClass: "do-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAdditionalData = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("— Vælg ekstra information —")]), _vm._v(" "), _vm._l((_vm.additionalDataOptions), function(option) {
    return _c('option', {
      key: option.ChildNumber,
      domProps: {
        "value": option.ChildNumber
      }
    }, [_vm._v("\n                  " + _vm._s(option.FirstName) + " " + _vm._s(option.LastName) + " - " + _vm._s(option.ChildNumber) + "\n                ")])
  })], 2) : (_vm.hasLoadedAdditionalData) ? _c('p', {
    staticClass: "opus-info__note"
  }, [_vm._v("\n                Der er ingen barn tilknyttet denne medarbejder i Opus.\n              ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.showValidationErrors && !_vm.isAdditionalDataValid) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("\n              Ekstra information skal vælges\n            ")]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (_vm.isOpusAllowOpen) ? _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Åbenstående")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__toggle-row"
  }, [_c('div', {
    staticClass: "do-opus-toggle",
    on: {
      "click": function($event) {
        _vm.isOngoing = !_vm.isOngoing
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "prop-on": _vm.isOngoing
    }
  }), _vm._v(" "), _c('span', [_vm._v("Indberet som åbenstående")])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "opus-info__field"
  }, [_c('label', {
    staticClass: "opus-info__label"
  }, [_vm._v("Tid")]), _vm._v(" "), (_vm.useTime) ? _c('div', {
    staticClass: "opus-info__date-text"
  }, [_vm._v("\n            " + _vm._s(_vm.formatTime(_vm.startTime)) + " - " + _vm._s(_vm.formatTime(_vm.endTime)) + "\n          ")]) : _c('div', {
    staticClass: "opus-info__date-text"
  }, [_vm._v("\n            Hel dag\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "opus-info__toggle-row opus-info__toggle-row--secondary"
  }, [_c('div', {
    staticClass: "do-opus-toggle",
    on: {
      "click": function($event) {
        _vm.useTime = !_vm.useTime
      }
    }
  }, [_c('app-toggle', {
    attrs: {
      "prop-on": !_vm.useTime
    }
  }), _vm._v(" "), _c('span', [_vm._v("Indberet som hel dag")])], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons d-modal__buttons__flex"
  }, [_c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--loading': _vm.isLoadingRejected
    },
    on: {
      "click": _vm.rejectRequest
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n['reject']) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn",
    class: {
      'do-bttn--loading': _vm.isLoadingApprove
    },
    on: {
      "click": _vm.approveRequest
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n['approve']) + "\n      ")])])])]), _vm._v(" "), (_vm.isShowAbsenceSidebar) ? _c('UserRequestAbsenceSidebar', {
    attrs: {
      "date": _vm.startDate,
      "requesterId": _vm.request.request_by_id
    },
    on: {
      "close": function($event) {
        _vm.isShowAbsenceSidebar = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-505775f7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserRequests/UserRequestListAnswer.vue
// module id = 1914
// module chunks = 1